/**
 * HandwritingConverterPage — Standalone tool entry for the Handwritten
 * Letter Converter, separate from the FTC Builder flow.  Lets users drop
 * in any PDF and get back a handwritten version without first generating
 * a full FTC dispute report.  The actual UI is the same modal component
 * the FTC Builder uses; we just render it permanently open and route
 * "Close" back to the dashboard.
 */
import { useNavigate } from "react-router-dom";
import HandwritingConverterModal from "../components/HandwritingConverterModal";

export default function HandwritingConverterPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh]" data-testid="handwriting-converter-page">
      <HandwritingConverterModal
        open={true}
        onClose={() => navigate("/")}
      />
    </div>
  );
}
